import React, { useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import BackButton from '../../components/BackButton';
import moment from 'moment';

const PurchaseHistoryPage = (props) => {
	const {
		getPurchaseHistory,
		resetPage,
		resetMeta,
		purchaseHistoryPageProps
	} = props;

	const { loadingTickets, tickets } = purchaseHistoryPageProps;

	useEffect(() => {
		getPurchaseHistory();
		// Clean-up
		return () => resetPage();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="page-wrapper">
			<Grid container>
				<BackButton
					returnLocation="tickets"
					returnName="Tickets"
					{...props}
				/>
				<Grid.Row style={{ background: '#fff', borderRadius: 5, boxShadow: '0 2px 5px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.19)' }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'nowrap',
							justifyContent: 'space-between',
							width: '100%',
							margin: '0px 15px 20px 15px',
							verticalAlign: 'center'
						}}
					>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<p style={{ fontSize: 15, color: '#075185', fontWeight: 'bold' }}>
								Laundry Purchase History
							</p>
						</div>
					</div>
					<div style={{ margin: '0px 15px', height: 500, width: '100%', overflow: 'auto', scrollbarWidth: 'thin' }}>
						{
							tickets.length > 0 ? tickets.map(ticket => {
								return (
									<div
										key={ticket._id}
										style={{
											border: '1px solid #D5D5D5',
											borderRight: `5px solid ${ticket.machine_type === 'washer' ? '#63CAE1' : '#A1CD6E'}`,
											display: 'flex',
											flexDirection: 'row',
											padding: '5px 15px',
											alignContent: 'center',
											alignItems: 'center',
											marginBottom: '10px',
											borderRadius: '7px',
											cursor: 'pointer'
										}}
										onClick={() => props.history.push(`/tickets/id?id=${ticket._id}`)}
									>
										<div style={{ flex: 1 }}>
											<div>
												<h4 style={{ fontSize: 12, ...ticket.machine_type === 'washer' ? { color: '#63CAE1' } : { color: '#A1CD6E' }, fontWeight: 'bold' }}>{ ticket?.service_type?.label }</h4>
											</div>
											<div>
												<small style={{ fontSize: 11, color: '#003366' }}>Date Purchased: {moment(ticket.created_at).format('MMMM DD, YYYY')}</small>
											</div>
											<div>
												<small style={{ fontSize: 11, color: '#003366' }}>Ticket Expiry: {ticket.expire_at && moment(ticket.expire_at).format('MMMM DD, YYYY')}</small>
											</div>
											<div>
												<small style={{ fontSize: 11, color: '#003366' }}>Invoice Number: {ticket.invoice_number}</small>
											</div>
											<div>
												<small style={{ fontSize: 11, color: '#003366' }}>Status: {
													ticket.usage_status === 'used'
														? 'Used'
														: ticket.usage_status === 'available'
															? (
																moment(ticket?.expire_at).isBefore(moment())
																	? 'Expired'
																	: 'Available'
															)
															: 'Error'
												}</small>
											</div>
										</div>
										<div>
											<h2 style={{...ticket.machine_type === 'washer' ? { color: '#63CAE1' } : { color: '#A1CD6E' }, fontWeight: 'bold', marginRight: '10px'}}>
												$ {parseFloat(ticket.price).toFixed(2)}
											</h2>
										</div>
									</div>
								);
							}) : 'No available ticket(s)'
						}
					</div>
				</Grid.Row>
			</Grid>
		</div>
	);
};

export default PurchaseHistoryPage;
